import { Component, OnInit, ViewChild } from '@angular/core';
import {
  InformesSearch, InformeContabilidadConsultas, FiltroInformeContabilidadConsultas, InformeConsultas,
  InformeContabilidadConsultasContenido
} from '../../../core/model/informes';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { InformesService } from '../../../core/services/informes/informes.service';
import { ComboGrupo, ComboCliente } from '../../../core/model/combos';
import { UsuarioCliente } from '../../../core/model/usuario-cliente';
import { PopulateService } from '../../../core/services/populate.service';
import { UsersService } from '../../../core/services/users.service';
import { ResizedEvent } from '../../../core/model/resized-event';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { FileManagerService } from '../../../core/services/files/file-manager.service';
import { DateTimeAdapter } from 'ng-pick-datetime';

@Component({
  selector: 'app-informeconsultas',
  templateUrl: './informeconsultas.component.html',
  styleUrls: ['./informeconsultas.component.css']
})
export class InformeconsultasComponent implements OnInit {

  @ViewChild('table') table: DatatableComponent;

  informeContabilidadConsultas: InformeConsultas;
  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };
  view: any[] = [500, 400];
  viewchar: any[] = [1000, 400];
  showLegend = true;
  showLabels = true;
  Boxtype = 'box-primary';

  tamanioRecuperar = 10;
  clienteSeleccionadoInforme: any;
  grupoSeleccionadoInforme: ComboGrupo;
  usuarioSeleccionadoInforme: any;
  cbGrupoContabilidad: ComboGrupo[];
  cbUsuarios: UsuarioCliente[];

  cbCliente: ComboCliente[] = [];
  cbClienteSelected: ComboCliente[] = [];

  grafico: any;

  clienteSeleccionado = undefined;
  filterFormContabilidad: FormGroup;

  sumatorioFinalContabilidad = new FormGroup({
    sumatorioLocalizadas: new FormControl(0),
    sumatorioBusquedas: new FormControl(0),
    sumatorioImagenes: new FormControl(0)
  });

  isDocoutUser: boolean;

  loading = false;
  constructor(
    private informesservice: InformesService,
    private toastr: ToastrService,
    private populateService: PopulateService,
    private authService: AuthenticationService,
    private userService: UsersService,
    private fileManager: FileManagerService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.getClientes();
    this.load();
  }

  load() {
    let desde = new Date();
    let hasta = new Date();
    hasta.setDate(hasta.getDate() - 30);
    this.filterFormContabilidad = this.formBuilder.group({
      clientecontable: ['-1'],
      grupocontable: ['-1'],
      solicitantecontable: ['-1'],
      fechaAltaInicial: [hasta],
      fechaAltaFinal: [desde]
    });
  }

  getClientes() {
    this.populateService.getComboCliente()
      .subscribe(
        clientes => {
          this.cbCliente = clientes;
          console.log(clientes);
        });
  }

  getLocalizados(CONTENIDO: InformeContabilidadConsultasContenido[]): number {
    let SUMATORIO = 0;
    if (CONTENIDO.length > 0) {
      CONTENIDO.forEach(con => {
        if (con.CONTABILIDAD !== null && con.CONTABILIDAD.length > 0) {
          con.CONTABILIDAD.forEach(cont => {
            if (cont.DESCRIPCION === 'Total Localizados') {
              SUMATORIO += cont.CANTIDAD;
            }
          });
        }
      });
    }
    return SUMATORIO;
  }

  getBusquedas(CONTENIDO: InformeContabilidadConsultasContenido[]): number {
    let SUMATORIO = 0;
    if (CONTENIDO.length > 0) {
      CONTENIDO.forEach(con => {
        if (con.CONTABILIDAD !== null && con.CONTABILIDAD.length > 0) {
          con.CONTABILIDAD.forEach(cont => {
            if (cont.DESCRIPCION === 'Total de Búsquedas') {
              SUMATORIO += cont.CANTIDAD;
            }
          });
        }
      });
    }
    return SUMATORIO;
  }

  getImagenes(CONTENIDO: InformeContabilidadConsultasContenido[]): number {
    let SUMATORIO = 0;
    if (CONTENIDO.length > 0) {
      CONTENIDO.forEach(con => {
        if (con.CONTABILIDAD !== null && con.CONTABILIDAD.length > 0) {
          con.CONTABILIDAD.forEach(cont => {
            if (cont.DESCRIPCION === 'Total Imágenes') {
              SUMATORIO += cont.CANTIDAD;
            }
          });
        }
      });
    }
    return SUMATORIO;
  }

  getExportInformeContabilidad(from: number) {
    const filtro = this.constructFilter();
    this.loading = true;
    this.fileManager.downloadFileExportReport(filtro, from, this.tamanioRecuperar)
      .subscribe(
        data => {
          this._saveAs('InformeConsultas.csv', data);
        },
        (e: Error) => {
          this.toastr.error('Ha ocurrido un error en la exportación del informe de consultas a un CSV');
          this.toastr.error(e.message);
        },
        () => this.loading = false);
  }

  private _saveAs(fileName: string, data: any) {
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    const blob = new Blob([data], { type: 'application/octet-stream' });
    let objectUrl = '';
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // save file for IE
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // save for other browsers: Chrome, Firefox
      objectUrl = URL.createObjectURL(blob);
      // window.open(objectUrl);
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
    }
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  constructFilter(): FiltroInformeContabilidadConsultas {
    const filtro = new FiltroInformeContabilidadConsultas();
    filtro.CLIENTE = this.filterFormContabilidad.controls['clientecontable'].value;
    filtro.FECHA_ALTA_INICIO = this.filterFormContabilidad.controls['fechaAltaInicial'].value;
    filtro.FECHA_ALTA_FINAL = this.filterFormContabilidad.controls['fechaAltaFinal'].value;
    filtro.SOLICITANTE = this.filterFormContabilidad.controls['solicitantecontable'].value;
    filtro.GRUPO = this.filterFormContabilidad.controls['grupocontable'].value;
    this.sumatorioFinalContabilidad.patchValue({ sumatorioLocalizadas: 0, sumatorioBusquedas: 0 });
    return filtro;
  }

  getInformeContabilidad(from: number) {
    const filtro = this.constructFilter();
    this.loading = true;

    this.informesservice.getInformeContabilidadConsultas(filtro, from, this.tamanioRecuperar)
      .subscribe(
        (r: InformeConsultas) => {
          let sumatorioLoc = 0;
          let sumatorioBus = 0;
          let sumatorioImg = 0;
          r.INFORME.map(
            (INFORME: InformeContabilidadConsultas) => {
              INFORME.LOCALIZADOS = this.getLocalizados(INFORME.CONTENIDOS);
              INFORME.BUSQUEDAS = this.getBusquedas(INFORME.CONTENIDOS);
              INFORME.IMAGENES = this.getImagenes(INFORME.CONTENIDOS);
              sumatorioLoc += INFORME.LOCALIZADOS;
              sumatorioBus += INFORME.BUSQUEDAS;
              sumatorioImg += INFORME.IMAGENES;
            }
          );
          this.informeContabilidadConsultas = r;
          this.sumatorioFinalContabilidad.patchValue({
            sumatorioLocalizadas: sumatorioLoc,
            sumatorioBusquedas: sumatorioBus,
            sumatorioImagenes: sumatorioImg
          });
        },
        (e) => {
          this.loading = false;
          this.toastr.error('Ha ocurrido un error al recuperar los datos del informe de consultas. Detalle: ' + e.error.Message);
          console.log(e);
        },
        () => this.loading = false
      );
  }

  onClientContabilidadChange(event) {
    this.filterFormContabilidad.patchValue({ grupocontable: undefined });
    this.filterFormContabilidad.patchValue({ solicitantecontable: undefined });
    this.cbGrupoContabilidad = [];
    this.cbUsuarios = [];
    this.recoverFilterCliente(this.clienteSeleccionadoInforme);
  }

  recoverFilterCliente(idcliente: any) {
    if (idcliente !== undefined && idcliente !== null) {
      this.populateService.getComboGrupoByCliente(idcliente)
        .subscribe(
          (r: ComboGrupo[]) => {
            this.cbGrupoContabilidad = r;
          },
          (e: Error) => this.toastr.error('No se ha podido recuperar los grupos del cliente seleccionado'));
      this.userService.getUsersByClient(idcliente)
        .subscribe(
          (r: UsuarioCliente[]) => {
            this.cbUsuarios = r;
          },
          (e: Error) => this.toastr.error('Ha ocurrido un error al obtener los usuarios del cliente seleccionado')
        );
    }
  }

  cleanFiltroContabilidad() {
    this.cleanFilter();
    this.getInformeContabilidad(0);
  }

  cleanFilter() {
    this.filterFormContabilidad.patchValue({
      fechaAltaInicial: undefined,
      fechaAltaFinal: undefined,
      solicitantecontable: undefined,
      grupocontable: undefined,
      clientecontable: undefined
    });
    this.cbGrupoContabilidad = [];
    this.cbUsuarios = [];
  }

  onSelect(event) {
    console.log(event);
  }

  onResized(event: ResizedEvent): void {
    if (this.table !== undefined) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onClientChange() {
    if (this.cbClienteSelected === undefined || this.cbClienteSelected === null ||
      this.cbClienteSelected.length === 0) {
      // Limpio todo
      this.cleanFilter();
      this.cbClienteSelected = [];
    }
    // 🐱‍👤 Si solo hay un cliente seleccionado recupero los demas filtros
    console.log('Selected => ' + this.cbClienteSelected);
    if (this.cbClienteSelected !== undefined && this.cbClienteSelected !== null &&
      this.cbClienteSelected.length === 1) {
      this.recoverFilterCliente(this.cbClienteSelected[0]);
    }
  }

  isAllClientsSelected(): boolean {
    if (this.cbCliente.length === this.cbClienteSelected.length) {
      return true;
    }
    return false;
  }

  isAnyClientSelected(): boolean {
    if (this.cbClienteSelected.length > 0) {
      return true;
    }
    return false;
  }

  isClientChecked(idcliente: number): boolean {
    const value = this.filterFormContabilidad.controls['clientecontable'].value;
    const isMultivalue = value instanceof Array;
    return value && (value === idcliente || (isMultivalue && value.some(v => v === idcliente)));
  }

  resizeSelect(clientSelect: NgSelectComponent) {
    clientSelect.close();
    setTimeout(function () {
      clientSelect.open();
    }, 50);
  }

  clearItem(clearFunction, item, ngSelectSelected) {
    clearFunction(item);
    this.resizeSelect(ngSelectSelected);
  }

  manageClients(clientSelect: NgSelectComponent) {
    const value = this.filterFormContabilidad.controls['clientecontable'].value;
    this.resizeSelect(clientSelect);
    if (value instanceof Array && value.length === this.cbCliente.length) {
      this.filterFormContabilidad.controls['clientecontable'].setValue(this.cbCliente);
      return;
    }

    const ids = this.cbCliente.map(client => client.Id);
    this.filterFormContabilidad.controls['clientecontable'].setValue(ids);
  }

}
